import classNames from 'classnames'

import styles from './Paragraphs.module.scss'

function Paragraphs({ paragraphs = [], className }) {
  return (
    <div className={classNames(styles.paragraphs, className)}>
      {paragraphs.map((p) => (
        <p key={p.id} className={styles.text}>
          {p.text}
        </p>
      ))}
    </div>
  )
}

export default Paragraphs
